<template>
  <v-sheet
    :color="$route.path === '/' ? `transparent` : `primary`"
    width="100%"
    :height="$route.path === '/' ? `40px` : ``"
    :class="
      $route.path === '/'
        ? `header d-flex align-center index py-lg-16 pt-md-16 pb-lg-5 pb-5 pt-10 pb-md-5`
        : `header d-flex align-center py-lg-3 py-2`
    "
  >
    <v-container class="py-0 px-md-0 d-flex justify-space-between">
      <div>
        <router-link to="/">
          <img
            class="logo"
            :height="xs ? '40px' : sm ? '45px' : '52px'"
            :src="files + informations.img"
            alt="Logo"
        /></router-link>
      </div>
      <div :class="$route.path === '/' ? `d-flex mb-3` : `d-flex`">
        <div
          class="d-inline-flex align-center ml-3 item"
          v-for="({ link, target, icon }, i) in socialList"
          :key="i"
        >
          <v-btn
            :href="link"
            :target="target"
            rounded
            icon
            class="d-flex text-decoration-none"
            :color="$route.path === '/' ? `primary` : `white`"
          >
            <v-icon size="23" color="white">
              {{ icon }}
            </v-icon>
          </v-btn>
        </div>
        <div class="pl-6 d-none d-sm-block">
          <v-btn
            class="
              white--text
              px-6
              font-weight-bold
              primary
              rounded-0
              text-sm-h6 text-body-1
            "
            height="48px"
            width="auto"
            depressed
            :to="{ hash: 'fale-conosco' }"
          >
            <span class="open-sans">Fale Conosco</span>
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { getSocial } from "../../config";
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    time: "",
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smOnly;
    },
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return this.$rest("social").item;
    },
    socialList() {
      return getSocial(this);
    },
  },
};
</script>

<style>
.header .logo {
  filter: drop-shadow(0px 0px 27px #00000091);
}
.header {
  position: absolute;
}
.header .item {
  margin-right: -10px;
}
.index {
  z-index: 3;
}
</style>
